import { render, staticRenderFns } from "./ComDashboardIndex.vue?vue&type=template&id=a55501ce"
import script from "./ComDashboardIndex.vue?vue&type=script&lang=js"
export * from "./ComDashboardIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports